import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Button } from '../components/Button';
import { ArrowRight, Home, FileText, Users, Zap, Layers, BookOpen, UserPlus, Shield, FileCheck } from 'lucide-react';
interface SitemapPageProps {
  onNavigate?: (path: string) => void;
}
export function SitemapPage({
  onNavigate
}: SitemapPageProps) {
  const pages = [{
    icon: Home,
    path: '/',
    title: 'Home',
    description: 'Main landing page introducing The Authority Engine program and its core value proposition.'
  }, {
    icon: FileText,
    path: '/blueprint',
    title: 'Blueprint',
    description: 'Detailed participant journey from entry to transformation, showing the complete program roadmap.'
  }, {
    icon: Zap,
    path: '/join',
    title: 'Join / Initiate Access',
    description: 'Program enrollment page with pricing, payment, and access to the WhatsApp community.'
  }, {
    icon: BookOpen,
    path: '/curriculum',
    title: 'Core Curriculum',
    description: 'Overview of all 10 modules covering positioning, content strategy, AI tools, and monetization.'
  }, {
    icon: Users,
    path: '/pods',
    title: 'Accountability Pods',
    description: 'Learn about small-group accountability systems and peer pressure mechanisms.'
  }, {
    icon: Zap,
    path: '/ai',
    title: 'AI Tools & Infrastructure',
    description: 'Discover how to build your AI-powered content machine and idea generation engine.'
  }, {
    icon: Layers,
    path: '/framework',
    title: 'Content Framework',
    description: 'Understand the custom content framework system and how to build your own.'
  }, {
    icon: UserPlus,
    path: '/affiliate',
    title: 'Affiliate Signup',
    description: 'Apply to become an affiliate partner and earn by referring participants to the program.'
  }, {
    icon: FileCheck,
    path: '/terms',
    title: 'Terms of Service',
    description: 'Legal terms and conditions for program participation and usage.'
  }, {
    icon: Shield,
    path: '/privacy',
    title: 'Privacy Policy',
    description: 'Information about data collection, usage, and privacy practices.'
  }];
  const copyToClipboard = (path: string) => {
    const fullUrl = window.location.origin + path;
    navigator.clipboard.writeText(fullUrl);
    alert(`Link copied: ${fullUrl}`);
  };
  return <div className="min-h-screen bg-[#f5f5f7] text-[#1f2933]" data-id="element-1743">
      <Navbar onNavigate={onNavigate} data-id="element-1744" />

      <section className="py-24" data-id="element-1745">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-1746">
          <div className="text-center mb-16" data-id="element-1747">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-1748">Site Map</h1>
            <p className="text-lg font-mono text-[#9ca3af] max-w-2xl mx-auto" data-id="element-1749">
              Complete directory of all pages on The Authority Engine website
            </p>
            <p className="text-sm font-mono text-[#9ca3af] mt-4" data-id="element-1750">
              All links are shareable - click "COPY LINK" to share specific
              pages
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-1751">
            {pages.map((page, idx) => <div key={idx} className="bg-white border-2 border-dashed border-[#9ca3af] p-6 hover:border-salon-red transition-colors group" data-id="element-1752">
                <div className="flex items-start gap-4" data-id="element-1753">
                  <div className="flex-shrink-0" data-id="element-1754">
                    <div className="w-12 h-12 bg-salon-red/10 flex items-center justify-center group-hover:bg-salon-red group-hover:text-white transition-colors" data-id="element-1755">
                      <page.icon className="w-6 h-6" data-id="element-1756" />
                    </div>
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-1757">
                    <h3 className="text-xl font-bold mb-2" data-id="element-1758">{page.title}</h3>
                    <p className="text-sm text-[#1f2933]/80 mb-4" data-id="element-1759">
                      {page.description}
                    </p>
                    <div className="flex items-center gap-3 flex-wrap" data-id="element-1760">
                      <Button size="small" onClick={() => onNavigate && onNavigate(page.path)} className="bg-salon-red hover:bg-salon-red/90 border-salon-red" data-id="element-1761">
                        VISIT_PAGE
                      </Button>
                      <button onClick={() => copyToClipboard(page.path)} className="font-mono text-xs text-[#9ca3af] hover:text-salon-red transition-colors" data-id="element-1762">
                        COPY_LINK
                      </button>
                      <span className="font-mono text-xs text-[#9ca3af]" data-id="element-1763">
                        {page.path}
                      </span>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>

          {/* Quick Actions */}
          <div className="bg-[#1f2933] text-white p-12 text-center" data-id="element-1764">
            <h2 className="text-2xl font-bold mb-4" data-id="element-1765">
              Ready to Build Your Authority?
            </h2>
            <p className="max-w-2xl mx-auto mb-8 text-[#f5f5f7]/80" data-id="element-1766">
              Start your transformation journey today with The Authority Engine
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1767">
              <Button size="large" onClick={() => onNavigate && onNavigate('/join')} className="bg-salon-red hover:bg-salon-red/90 border-salon-red" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-1769" />} data-id="element-1768">
                INITIATE_ACCESS
              </Button>
              <Button size="large" variant="secondary" onClick={() => onNavigate && onNavigate('/blueprint')} data-id="element-1770">
                VIEW_BLUEPRINT
              </Button>
            </div>
          </div>
        </div>
      </section>

      <Footer onNavigate={onNavigate} data-id="element-1771" />
    </div>;
}